import { SxProps, Theme } from '@mui/material'
import { InitialsAvatar } from './InitialsAvatar'

export type AssigneeAvatarOption = {
  id: string
  value: string
  isArchived?: boolean
}

export const AssigneeAvatar = ({
  option,
  sx,
  size = 20,
}: {
  option: AssigneeAvatarOption
  sx?: SxProps<Theme>
  size?: 20 | 24
}) => {
  return <InitialsAvatar size={size} fullName={option.value} colourSubjectId={option.id} isArchived={option.isArchived} sx={sx} />
}
